module.exports = __webpack_public_path__ + "static/media/non.0327d74c.png";